import * as React from "react";
export var renderArrow = function (componentPrefix) {
    return (React.createElement("div", { className: "rj-ev-list__" + componentPrefix + "__section-item rj-ev-list__" + componentPrefix + "__arrow-wrap" },
        React.createElement("span", { className: "rj-ev-list__" + componentPrefix + "__arrow" })));
};
//# sourceMappingURL=renderArrow.js.map